import { CloudSunIcon, GlobeIcon, LayersIcon, ThermometerSunIcon, WavesIcon, WindIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '01',
    title: "Weather, Climate & Earth's Energy Balance: The Atmosphere and the Greenhouse Effect",
    summary: 'A visual teaching reference to how sunlight, air and invisible gases set the temperature of our planet.',
    icon: CloudSunIcon,
  },
  {
    number: '02',
    title: 'The Climate System in Motion: Oceans, Ice, Atmospheric Circulation, Water & Carbon Cycles',
    summary: 'A visual teaching reference to how air, oceans, ice, water and carbon move energy around our planet.',
    icon: WavesIcon,
  },
  {
    number: '03',
    title: "Reading Earth's Climate History: Paleoclimate, Ice Cores & Natural Climate Change",
    summary: 'A visual teaching reference to how scientists read ice, rings, rocks and shells to reconstruct climates long before thermometers.',
    icon: LayersIcon,
  },
  {
    number: '04',
    title: 'Modern Climate Change: Evidence, Causes, Measurement & Climate Models',
    summary: 'A visual teaching reference to how scientists measure a warming world, identify its causes and model the climate.',
    icon: GlobeIcon,
  },
  {
    number: '05',
    title: 'Impacts of Climate Change: Oceans, Ice, Extreme Weather, Ecosystems & People',
    summary: 'A visual teaching reference to how a warming world affects seas, ice, weather, living things and communities.',
    icon: ThermometerSunIcon,
  },
  {
    number: '06',
    title: 'Responding to Climate Change: Mitigation, Adaptation, Policy & Teaching Climate with Confidence',
    summary: 'A visual teaching reference to how societies reduce emissions, prepare for change and decide together — and how to teach it well.',
    icon: WindIcon,
  },
];
